var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocuments2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 470.46 470.46",
    style: {
      enableBackground: "new 0 0 470.46 470.46"
    },
    xmlSpace: "preserve",
    fill: "#f7f7f7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M386.11,69.765V34.882h-34.882V0H131.905L49.468,82.437v318.259h34.883v34.883h34.882v34.882h301.76V69.765H386.11z  M127.805,23.899v54.437H73.367L127.805,23.899z M63.468,92.336h78.337V14h195.424v372.695H63.468V92.336z M98.351,400.695h252.878 V48.882h20.882v372.696H98.351V400.695z M406.992,456.46h-273.76v-20.882H386.11V83.765h20.882V456.46z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 109.431,
    width: 192.932,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 146.83,
    width: 192.932,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 184.229,
    width: 192.932,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 221.629,
    width: 192.932,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 259.028,
    width: 192.932,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 296.427,
    width: 192.932,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.882,
    y: 333.826,
    width: 192.932,
    height: 14
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments2);
export default __webpack_public_path__ + "static/media/documents2.72aaae90afe935a1afa80026d6b55190.svg";
export { ForwardRef as ReactComponent };